"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FormControl2 = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var FormControl = /*#__PURE__*/(0, _react.forwardRef)(function FormControl(props, ref) {
  var intent = props.intent,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["intent"]);
  var error = intent === 'error';
  return /*#__PURE__*/_react.default.createElement(_FormControl2.default, Object.assign({}, otherProps, {
    error: error,
    ref: ref
  }));
});
FormControl.propTypes = {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,

  /**
   * The CSS class name to add to the root node of the component.
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * If it should have the `error`, `warning` or default styles.
   */
  intent: _propTypes.default.oneOf([undefined, 'error', 'warning']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
};
var _default = FormControl;
exports.default = _default;
